import get from 'lodash/get';

export const OrganizationCategory = (item) => ({
  id: get(item, 'id') || '',
  name: get(item, 'name') || '',
  count: get(item, 'count') || 0
});